<ion-header>
  <ion-toolbar>
    <ion-title>{{ texts.table.columnsTitle | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-header>
  <mat-selection-list id="header-item-content-column-selection">
    <ion-item lines="none">
      <mat-list-option
        (click)="onToggleAll()"
        [selected]="oneSelected$ | async">
        <ion-col>
          <span mat-line>{{ texts.general.selectAll | translate }}</span>
        </ion-col>
      </mat-list-option>
    </ion-item>
  </mat-selection-list>
</ion-header>

<ion-content>
  <div>
    <mat-selection-list
      (cdkDropListDropped)="drop($event)"
      actualContainer="mat-selection-list.column-container"
      cdkDropList
      class="column-container">
      <mat-list-option
        *ngFor="let col of list$ | async; let i = index"
        (click)="onSelection(i)"
        cdkDrag
        [disabled]="col?.disabled"
        [selected]="col.selected">
        <ion-row class="ion-align-items-center">
          <ion-col size="2" class="icon-container">
            <mat-icon mat-list-icon>
              <ion-icon name="menu-outline"></ion-icon>
            </mat-icon>
          </ion-col>
          <ion-col>
            <span mat-line>{{ col?.text | translate }}</span>
          </ion-col>
        </ion-row>
      </mat-list-option>
    </mat-selection-list>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-text-center">
      <ion-row>
        <ion-col>
          <ion-tab-button (click)="handleOnSave()">
            <ion-icon name="save"></ion-icon>
            <ion-label>
              {{ texts.general.save | translate }}
            </ion-label>
          </ion-tab-button>
        </ion-col>
        <ion-col>
          <ion-tab-button (click)="handleOnCancel()">
            <ion-icon name="arrow-back"></ion-icon>
            <ion-label>{{ texts.general.cancel | translate }}</ion-label>
          </ion-tab-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
